import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * «Отчёты» (AUT-403). Company-owned reports arrive with CP-05 (reports get
 * an `org_id`, and `/admin/orgs/:id/reports` follows); until then there is
 * nothing to list, and a fake zero would read as «the company did no work».
 * So this tab says what will be here and why it is empty.
 */
export const ReportsTab = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="subtitle1" fontWeight={700}>
        {t('companies.reports.emptyTitle')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, maxWidth: 560, mx: 'auto' }}>
        {t('companies.reports.emptyBody')}
      </Typography>
    </Paper>
  );
};
